export default {
  SET_MINIMIZED(state, payload) {
    state.minimized = payload;
  },
  SET_PINNED(state, payload) {
    state.pinned = payload;
  },
  SET_MOUSEOVER(state, payload) {
    state.mouseover = payload;
  },
  SET_AUTOMATIC(state, payload) {
    state.automatic = payload;
  },
};
